module.exports = __webpack_public_path__ + "img/banner.00a98208.jpg";